import { Command, Plus } from "react-feather";
import { getalldrones } from "../../api/dronesAPI";
import { useAuthStore } from "../../store/authStore";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../../components/UI/Spinner";
import { useNavigate } from "react-router-dom";
import { capitalize } from "../../helpers/commonFunction";
import { useEffect } from "react";
import { useMapStore } from "../../store/mapStore";
import { useForm } from "react-hook-form";
import { Information, LocationCurrent } from "@carbon/icons-react";

const DronesPage = () => {
    const {
        register,
        watch,
    } = useForm();
    const appStatValDrones = ["approved", "pending", "rejected"];
    const { token, setLoaderState, isPilot } = useAuthStore((state) => state);
    const droneApprovalStatus = isPilot ? "approved" : watch("droneApprovalStatus");
    const navigate = useNavigate();
    const { setUserDronesIdsStore } = useMapStore((state) => state)
    const { isLoading, data, error } = useQuery({
        queryFn: getalldrones,
        queryKey: ["getDrones", token, droneApprovalStatus],
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading])

    useEffect(() => {

        if (data?.data?.data) {
            const dronesId = data?.data?.data?.map((drone) => {
                return drone.droneId
            })
            setUserDronesIdsStore(dronesId)
        }
    }, [data])

    return (
        <>
            <div className="p-4">
                <div className="grid grid-cols-2 mb-6">
                    <div className="grid grid-cols-2">
                        <h1 className="text-4xl w-full h-full ">My Drones</h1>
                        <div className=" w-fit">
                            {!isPilot && <select
                                {...register("droneApprovalStatus", { required: true })}
                                className="w-full cursor-pointer block p-3 border-slate-200 border rounded-xl focus:outline-none"
                            >
                                {appStatValDrones.map((val, index) => (
                                    <option key={index} value={val} className="capitalize">
                                        {capitalize(val)}
                                    </option>
                                ))}
                            </select>}
                        </div>
                    </div>
                    <div className="flex justify-end">
                        {!isPilot && (
                            <button
                                onClick={() => navigate("/layout/add-drone")}
                                className="bg-tblu flex h-fit text-white whitespace-nowrap p-4 text-md rounded-xl w-fit"
                            >
                                <Plus /> &ensp; Add drone
                            </button>
                        )
                        }
                    </div>
                </div>
                <hr />
                <div className="mt-10 drones-list">
                    {isLoading && <Spinner />}
                    {data?.data?.data?.length === 0 ? (
                        <div className="flex w-full justify-center">
                            <span className="text-slate-400 text-xl">No drones added</span>
                        </div>
                    ) : (
                        <div className="w-full flex flex-wrap justify-between">
                            {
                                data?.data?.data?.map((drone, index) => (
                                    <div
                                        key={index}
                                        className="drone-card  bg-zinc-50 shadow-md p-4 border rounded-xl my-4 w-[20vw]"

                                    >
                                        <div>
                                            <div className="flex items-center justify-between">
                                                <div className="flex">
                                                    <Command size={32} className="text-tblu" />
                                                    &ensp;
                                                    <h1 className="text-xl">{capitalize(drone.droneName)}</h1>
                                                </div>
                                                <div className="flex space-x-3 cursor-pointer">
                                                    <Information size={32} className="text-tblu"
                                                        onClick={() => {
                                                            navigate(`/dashboard/drone-details/${drone.droneId}`)
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                            <div className="flex justify-between mt-5">
                                                <div>
                                                    <h2 className="text-zinc-400 font-bold">

                                                        {drone.droneUin}
                                                    </h2>
                                                </div>
                                                <div>
                                                    <div className="bg-tblu px-3 py-2 rounded-lg">

                                                        <h2 className="text-white font-bold uppercase">
                                                            {(drone.droneCategory)}
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                    )
                    }
                </div>
            </div>
        </>
    )
}

export default DronesPage;